module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed-lists"
  }, _vm._l((_vm.list), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "feed-list-item no-radius",
      on: {
        "click": function($event) {
          return _vm.onItemClick($event, item)
        }
      }
    }, [(item.author) ? _c('div', {
      staticClass: "media",
      class: {
        'essence': item.is_essence === 1
      }
    }, [_c('div', {
      staticClass: "text-normal relative",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.userLink(item)
        }
      }
    }, [_c('div', {
      staticClass: "pull-left avatar m-r avatar-lg avatar-circle",
      class: {
        'bg-color': !item.author.avatar
      }
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.author.avatar, 'avatar')
      }
    })]), _vm._v(" "), (item.author.isrv == 1) ? _c('div', {
      staticClass: "is-certify"
    }, [_c('img', {
      attrs: {
        "src": "https://img01.wanfangche.com/public/upload/201804/13/5ad0552c60b29.png?x-oss-process=style/large",
        "alt": "认证车主",
        "width": "100%",
        "height": "100%"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [(_vm.currentUser.user_id && _vm.currentUser.user_id != item.author.id) ? _c('div', {
      staticClass: "pull-right text-center text-muted"
    }, [(item.author.is_follow == 0) ? _c('a', {
      staticClass: "btn btn-follow",
      class: {
        'feed-followed': item.author.is_follow == 1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doFollow(item)
        }
      }
    }, [_vm._v("\n        关注")]) : _vm._e(), _vm._v(" "), (item.author.is_follow == 2) ? _c('a', {
      staticClass: "btn btn-follow",
      class: {
        'feed-followed': item.author.is_follow == 2
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doFollow(item)
        }
      }
    }, [_vm._v("\n        已关注")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-normal feed-list-name1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.userLink(item)
        }
      }
    }, [_c('div', {
      staticClass: "text-bolder text-md"
    }, [_vm._v(_vm._s(item.author.nickname || '车友')), _c('gender', {
      model: {
        value: (item.author.sex),
        callback: function($$v) {
          _vm.$set(item.author, "sex", $$v)
        },
        expression: "item.author.sex"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "text-muted text-small m-t-3"
    }, [_vm._v(_vm._s(item.publish_time || item.publish_date))])])])]) : _vm._e(), _vm._v(" "), (item.content) ? _c('div', {
      staticClass: "feed-content block",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onItemClick($event, item)
        }
      }
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.topic_name),
        expression: "item.topic_name"
      }],
      staticClass: "feed_content_tag",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goTopic(item.topic_name)
        }
      }
    }, [_vm._v("#" + _vm._s(item.topic_name) + "#")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 140
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }), _vm._v(" "), (item.content.length >= 103) ? _c('a', [_vm._v("全文")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type >= 3 && item.post_detail && item.post_detail.type == 0) ? _c('div', {
      staticClass: "feed-content block feed-contents",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onItemClick($event, item.post_detail)
        }
      }
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.post_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 140
      },
      model: {
        value: (item.post_detail.content),
        callback: function($$v) {
          _vm.$set(item.post_detail, "content", $$v)
        },
        expression: "item.post_detail.content"
      }
    }), _vm._v(" "), (item.content.length >= 103) ? _c('a', [_vm._v("全文")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type == 4 && item.cms_detail && item.cms_detail.content) ? _c('div', {
      staticClass: "feed-content block feed-contents"
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.cms_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 140
      },
      model: {
        value: (item.cms_detail.content),
        callback: function($$v) {
          _vm.$set(item.cms_detail, "content", $$v)
        },
        expression: "item.cms_detail.content"
      }
    }), _vm._v(" "), (item.content.length >= 103) ? _c('a', [_vm._v("全文")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type >= 3 && item.post_detail && (item.post_detail.type == 1 || item.post_detail.type == 2)) ? _c('div', {
      staticClass: "feed-share-container"
    }, [_c('div', {
      staticClass: "feed-share no-radius",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.campLink(item.post_detail)
        }
      }
    }, [_c('div', {
      staticClass: "pull-left share-info-img m-r feed-item-camp"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.post_detail.camp_detail.imgpath, 'small'),
        "width": "100%"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-list-item"
    }, [_c('div', {
      staticClass: "text-md text-bolder share-info-name over-omit"
    }, [_vm._v(_vm._s(item.post_detail.camp_detail.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-muted share-info-others m-b-3",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticClass: "camp-xing"
    }, _vm._l((_vm.xing), function(items) {
      return _c('i', {
        staticClass: "icon-camp-collection",
        class: {
          'actives': items <= item.post_detail.camp_detail.score
        }
      })
    }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.camp_detail.price))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "camp-level-icon camp-level-icons pull-left",
      class: {
        'color-camp2': item.post_detail.camp_detail.type == 1, 'color-park2': item.post_detail.camp_detail.type == 0, 'color-scenic2': item.post_detail.camp_detail.type == 2, 'color-food2': item.post_detail.camp_detail.type == 3, 'color-fix2': item.post_detail.camp_detail.type == 4, 'color-refuel2': item.post_detail.camp_detail.type == 5
      }
    }, [_c('span', {
      class: {
        'icon-camp-camp': item.post_detail.camp_detail.type == 1, 'icon-camp-park': item.post_detail.camp_detail.type == 0, 'icon-camp-scenic': item.post_detail.camp_detail.type == 2, 'icon-camp-food': item.post_detail.camp_detail.type == 3, 'icon-camp-service': item.post_detail.camp_detail.type == 4, 'icon-camp-station': item.post_detail.camp_detail.type == 5
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-level-txt camp-level-txts pull-left text-sm",
      class: {
        'color-camp1': item.post_detail.camp_detail.type == 1, 'color-park1': item.post_detail.camp_detail.type == 0, 'color-scenic1': item.post_detail.camp_detail.type == 2, 'color-food1': item.post_detail.camp_detail.type == 3, 'color-fix1': item.post_detail.camp_detail.type == 4, 'color-refuel1': item.post_detail.camp_detail.type == 5
      }
    }, [_vm._v("\n            " + _vm._s(item.post_detail.camp_detail.scale) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), (item.type == 2 || item.type == 1) ? _c('div', {
      staticClass: "feed-share-container"
    }, [_c('div', {
      staticClass: "feed-share no-radius",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.campLink(item)
        }
      }
    }, [_c('div', {
      staticClass: "pull-left share-info-img m-r feed-item-camp"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.camp_detail.imgpath, 'small'),
        "width": "100%"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-list-item"
    }, [_c('div', {
      staticClass: "text-md text-bolder share-info-name over-omit"
    }, [_vm._v(_vm._s(item.camp_detail.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-muted share-info-others m-b-3",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticClass: "camp-xing"
    }, _vm._l((_vm.xing), function(items) {
      return _c('i', {
        staticClass: "icon-camp-collection",
        class: {
          'actives': items <= item.camp_detail.score
        }
      })
    }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.camp_detail.price))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "camp-level-icon camp-level-icons pull-left",
      class: {
        'color-camp2': item.camp_detail.type == 1, 'color-park2': item.camp_detail.type == 0, 'color-scenic2': item.camp_detail.type == 2, 'color-food2': item.camp_detail.type == 3, 'color-fix2': item.camp_detail.type == 4, 'color-refuel2': item.camp_detail.type == 5
      }
    }, [_c('span', {
      class: {
        'icon-camp-camp': item.camp_detail.type == 1, 'icon-camp-park': item.camp_detail.type == 0, 'icon-camp-scenic': item.camp_detail.type == 2, 'icon-camp-food': item.camp_detail.type == 3, 'icon-camp-service': item.camp_detail.type == 4, 'icon-camp-station': item.camp_detail.type == 5
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-level-txt camp-level-txts pull-left text-sm",
      class: {
        'color-camp1': item.camp_detail.type == 1, 'color-park1': item.camp_detail.type == 0, 'color-scenic1': item.camp_detail.type == 2, 'color-food1': item.camp_detail.type == 3, 'color-fix1': item.camp_detail.type == 4, 'color-refuel1': item.camp_detail.type == 5
      }
    }, [_vm._v("\n            " + _vm._s(item.camp_detail.scale) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), (item.video) ? _c('div', {
      staticClass: "text-center video-padder"
    }, [_c('video-view', {
      attrs: {
        "src": item.video,
        "allowfullscreen": ""
      }
    })], 1) : (item.video_object) ? _c('div', {
      staticClass: "text-center video-padder"
    }, [_c('video-view', {
      attrs: {
        "src": item.video_object.src,
        "poster": item.video_object.poster || '',
        "allowfullscreen": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type == 7 && item.post_detail.type == 0 && item.post_detail.video) ? _c('div', {
      staticClass: "text-center video-padder feed-contents top-0"
    }, [_c('video-view', {
      attrs: {
        "src": item.post_detail.video,
        "allowfullscreen": ""
      }
    })], 1) : (item.type == 7 && item.post_detail.type == 0 && item.post_detail.video_object) ? _c('div', {
      staticClass: "text-center video-padder feed-contents top-0"
    }, [_c('video-view', {
      attrs: {
        "src": item.post_detail.video_object.src,
        "poster": item.post_detail.video_object.poster || '',
        "allowfullscreen": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), ((item.type == 3 || item.type == 5) && item.cms_detail) ? _c('div', {
      staticClass: "text-center video-padder feed-contents",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goCms(item.cms_detail)
        }
      }
    }, [_c('div', {
      staticClass: "article-content"
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.cms_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 40
      },
      model: {
        value: (item.cms_detail.title),
        callback: function($$v) {
          _vm.$set(item.cms_detail, "title", $$v)
        },
        expression: "item.cms_detail.title"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "article-poster"
    }, [_c('img', {
      attrs: {
        "src": item.cms_detail.poster || 'https://img01.wanfangche.com/public/upload/201908/27/5d64e4d1e3a9a.png?x-oss-process=style/middle',
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (item.type == 6 && item.article_detail) ? _c('div', {
      staticClass: "text-center video-padder feed-contents",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goArticle(item.article_detail)
        }
      }
    }, [_c('div', {
      staticClass: "article-content"
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.article_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 40
      },
      model: {
        value: (item.article_detail.title),
        callback: function($$v) {
          _vm.$set(item.article_detail, "title", $$v)
        },
        expression: "item.article_detail.title"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "article-poster"
    }, [_c('img', {
      attrs: {
        "src": item.article_detail.poster || 'https://img01.wanfangche.com/public/upload/201908/27/5d64e4d1e3a9a.png?x-oss-process=style/middle',
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (item.type == 4 && item.cms_detail) ? _c('div', {
      staticClass: "text-center video-padder feed-contents top-0 ",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goCms(item.cms_detail)
        }
      }
    }, [_c('div', {
      staticClass: "article-video-poster"
    }, [_c('img', {
      attrs: {
        "src": item.cms_detail.poster,
        "alt": ""
      }
    }), _vm._v(" "), _c('span')])]) : _vm._e(), _vm._v(" "), (item.type == 7 && item.post_detail.type == 0 && item.post_detail.img.length > 0 && (!item.post_detail.video_object && !item.post_detail.video)) ? _c('a', {
      staticClass: "block feed-contents top-0",
      class: {
        'p-t-4': item.post_detail.video, 'p-b-4': item.post_detail.video
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onItemClick($event, item.post_detail)
        }
      }
    }, [(item.post_detail.video) ? _c('div', [(item.post_detail.img && item.post_detail.img.length < 2 && item.post_detail.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.post_detail.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.post_detail.img.length > 1 && item.post_detail.img.length < 4) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.post_detail.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item.post_detail.img.length > 3) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, [_vm._l((item.post_detail.imgs), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('a', {
      staticClass: "col-xs-4 feed-item-img",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "row thumb-feed-img feed-img-text"
    }, [_c('div', {
      staticClass: "feed-img-modal"
    }, [_vm._v("+" + _vm._s(item.post_detail.img.length - 3))])])])], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.post_detail.video) ? _c('div', {
      class: {
        'p-t-4': item.post_detail.img.length == 1, 'p-b-4': item.post_detail.img.length == 1
      }
    }, [(item.post_detail.img && item.post_detail.img.length < 2 && item.post_detail.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.post_detail.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.post_detail.img.length > 1) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.post_detail.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img1"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.img.length > 0) ? _c('router-link', {
      staticClass: "block",
      class: {
        'p-t-4': item.video, 'p-b-4': item.video
      },
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [(item.video) ? _c('div', [(item.img && item.img.length < 2 && item.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.img.length > 1 && item.img.length < 4) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item.img.length > 3) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, [_vm._l((item.imgs), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('a', {
      staticClass: "col-xs-4 feed-item-img",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "row thumb-feed-img feed-img-text"
    }, [_c('div', {
      staticClass: "feed-img-modal"
    }, [_vm._v("+" + _vm._s(item.img.length - 3))])])])], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.video) ? _c('div', {
      class: {
        'p-t-4': item.img.length == 1, 'p-b-4': item.img.length == 1
      }
    }, [(item.img && item.img.length < 2 && item.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.img.length > 1) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img1"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.camp_name) ? _c('div', {
      staticClass: "block p-t-4 p-b-4"
    }, [_c('a', {
      staticClass: "camp-min font-12 over-omit",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.campBtn(item.camp_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon"
    }), _c('span', [_vm._v(_vm._s(item.camp_name))])])]) : _vm._e(), _vm._v(" "), (item.address) ? _c('div', {
      staticClass: "block p-t-4 p-b-4"
    }, [_c('a', {
      staticClass: "location-show font-12 over-omit",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.locationLink(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa icon-camp-address m-r"
    }), _vm._v(_vm._s(item.address) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear block feed-item-candle m-t-8",
      class: {
        'border-none': item.type >= 3
      }
    }, [_c('div', {
      staticClass: "btn-group pull-right m-t-8 text-muted m-r--12"
    }, [_c('router-link', {
      staticClass: "table-box text-xlg btn text-muted text-top p-r-0",
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "text-xlg fd-comment table-cell "
    }), _vm._v(" "), _c('span', {
      staticClass: "text-md table-cell padder-xs no-line-height p-r-0 comment-width"
    }, [_vm._v(_vm._s(item.reply_num || ''))])]), _vm._v(" "), _c('a', {
      staticClass: "btn  no-hover table-box",
      class: item.is_follow === 1 ? 'text-default' : 'text-muted',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.thumbUp(item)
        }
      }
    }, [_c('i', {
      staticClass: "text-xlg table-cell",
      class: item.is_follow ? 'fd-thumb-up' : 'fd-thumb-o-up'
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.credit_num != 0),
        expression: "item.credit_num!=0"
      }],
      staticClass: "text-md table-cell padder-xs no-line-height"
    }, [_vm._v(_vm._s((item.credit_num && item.credit_num > 0) ? item.credit_num : ''))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "m-t-12 text-muted"
    }, [_c('span', {
      staticClass: "m-r text-md"
    }, [_vm._v(_vm._s(item.read_num) + "次浏览")])])]), _vm._v(" "), (item.post_content && item.post_content.length > 0) ? _c('div', {
      staticClass: "feed-comment-list m-t-sm"
    }, [_c('router-link', {
      staticClass: "block text-normal",
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._l((item.post_content), function(comment, index) {
      return _c('div', {
        staticClass: "feed-comment-item",
        class: {
          'p-b-0': index == (item.post_content.length - 1)
        }
      }, [(comment.author) ? _c('div', {
        staticClass: "pull-left avatar-circle avatar-xs"
      }, [_c('img', {
        attrs: {
          "src": _vm._f("ossResize")(comment.author.avatar, 'avatar')
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "media-body text-md"
      }, [_c('span', {
        staticClass: "text-lt text-bold"
      }, [_vm._v(_vm._s(comment.author.nickname))]), _vm._v(":\n          "), _c('text-view', {
        attrs: {
          "length": 100
        },
        model: {
          value: (comment.content),
          callback: function($$v) {
            _vm.$set(comment, "content", $$v)
          },
          expression: "comment.content"
        }
      })], 1)])
    }), _vm._v(" "), _c('div', {
      staticClass: "padder-v-sm p-t-7",
      class: {
        'p-t-4': item.reply_num < 4, 'p-b-4': item.reply_num < 4
      }
    }, [(item.reply_num > 3) ? _c('router-link', {
      staticClass: "block tag-color",
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("查看所有" + _vm._s(item.reply_num) + "条评论")]) : _vm._e()], 1)], 2)], 1) : _vm._e()], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-442ed1ac"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/feed/list-item.vue
// module id = 278
// module chunks = 107